// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Lightbulb as RawLightbulb } from "lucide-react";
export const Lightbulb = /* @__PURE__ */ createIcon(RawLightbulb, "Lightbulb", 2);
